const ModuleNameSpaces = {
  Auth: 'auth',
};

export default ModuleNameSpaces;
